import React, { useState, useEffect } from "react";

// Import raw file content directly
// Note: In a real setup, you would need to configure webpack with raw-loader
// For this demo, we'll use the stored file content
const FirstCode = () => {
  const [codeContent, setCodeContent] = useState("");

  useEffect(() => {
    // Read the file content directly from the assets directory
    fetch(process.env.PUBLIC_URL + "/assets/first-code.cpp")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch file");
        }
        return response.text();
      })
      .then((text) => {
        setCodeContent(text);
      })
      .catch((error) => {
        console.error("Error loading code file:", error);
        // Fallback to hardcoded version
        setCodeContent(error);
      });
  }, []);

  // Format code with line numbers
  const formatCodeWithLineNumbers = () => {
    if (!codeContent) return null;

    const lines = codeContent.split("\n");
    return lines.map((line, index) => (
      <div key={index} className="code-line" style={{ display: "flex" }}>
        <span
          className="line-number"
          style={{
            userSelect: "none",
            textAlign: "right",
            color: "#858585",
            paddingRight: "16px",
            width: "40px",
            borderRight: "1px solid #333",
            marginRight: "12px",
          }}
        >
          {index + 1}
        </span>
        <span className="line-content" style={{ color: "#d4d4d4" }}>
          {line}
        </span>
      </div>
    ));
  };

  return (
    <div
      style={{
        paddingBottom: "80px",
      }}
    >
      <div
        style={{
          paddingTop: "20px",
          marginBottom: "20px",
          width: "100%",
        }}
      >
        <h2 className="subtitle">My Coding Origin Story 🚀</h2>
        <p
          style={{
            color: "#a0a0a0",
            marginBottom: "15px",
            fontWeight: "500",
            fontSize: "15px",
          }}
        >
          This is literally the first piece of code I ever wrote!
          <br />A simple quadratic equation solver (y = ax² + bx + c)
        </p>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          margin: "20px auto",
          backgroundColor: "#1e1e1e", // VS Code default dark background
          borderRadius: "6px",
          maxWidth: "800px",
          border: "1px solid #333333",
          overflow: "hidden",
          animation: "fadeIn 0.8s ease-in",
        }}
      >
        <div
          style={{
            width: "100%",
            backgroundColor: "#252526", // VS Code title bar color
            padding: "8px 16px",
            borderBottom: "1px solid #333333",
          }}
        >
          <h3
            style={{
              color: "#e5e5e5",
              margin: "0",
              fontWeight: "normal",
              fontSize: "14px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <span style={{ marginRight: "5px", marginLeft: "15px" }}>📄</span>
            first-code.cpp
          </h3>
        </div>

        <div style={{ width: "100%", padding: "16px 0" }}>
          <div
            style={{
              backgroundColor: "#1e1e1e",
              width: "100%",
              overflow: "auto",
              fontFamily: "'Consolas', 'Courier New', monospace",
              fontSize: "14px",
              lineHeight: "1.5",
              padding: "0 16px",
            }}
          >
            {formatCodeWithLineNumbers()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FirstCode;
